export const FormFormat = {
    designation:"",
    email:"",
    lastname:"",
    firstname:"",
    picturepath : "",
    uploadedPic :"",
    oldPassword:"",
    newPassword:"",
    confirmPassword:""
}
export const passwordObj = {
    oldPassword:"",
    newPassword:"",
    confirmPassword:""
}